import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentAboutDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-incidentabout-container',
  templateUrl: './incidentabout-container.component.html',
  styleUrls: ['./incidentabout-container.component.scss']
})
export class IncidentaboutContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentAbouts$: Observable<IncidentAboutDto[]>;
  loading: boolean;
  isLoadingIncidentAbout$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingIncidentAbout$ = this.gatwayFacade.isLoadingGateway("IncidentAbout");
    this.incidentAbouts$ = this.gatwayFacade.loadGateway("IncidentAbout");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentAbout(deletedValue: any) {
    this.gatwayFacade.remove("IncidentAbout", deletedValue);
  }


// this method control both the create and update

  onSubmitIncidentAbout(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentAbouts;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentAbout = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentAbout.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllIncidentAbout.length > 0) {
    this.gatwayFacade.add('IncidentAbout', addAllIncidentAbout);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentAbout', allUpdates, ['id']);
  }


}
}



  
   




